import { combineReducers } from 'redux';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { get } from 'lodash';
import { routerReducer, LOCATION_CHANGE } from 'react-router-redux';
import { reducer as impressions } from '@nerdwallet/nw-client-lib/tracking';
import parseParams from './parse-params';

import * as Actions from './actions';
import search from './reducers/search';
import productSearch from './reducers/product-search';

const errors = (state = [], action) => {
  switch (action.type) {
    case Actions.REQUEST_ERROR:
      return [...state, action.error];
    default:
      return state;
  }
};

const params = (state = {}, action) => {
  if (action.type !== LOCATION_CHANGE) return state;
  return parseParams(get(action, 'payload.search', ''));
};

export const combinedReducers = combineReducers({
  routing: routerReducer,
  errors,
  search,
  productSearch,
  params,
  impressions,
});

export default function rootReducer(state = {}, action) {
  return combinedReducers(state, action);
}
